import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PostsService } from '../modules/core/services/posts.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-token-login',
  template: `
    <p *ngIf="loading">Provjera tokena...</p>
    <p *ngIf="error">{{ error }}</p>
  `
})
export class TokenLoginComponent implements OnInit {
   email: string | null = null;
   loading: boolean = true;
   error: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient

  ) {}



   ngOnInit(): void {

   const token = this.route.snapshot.paramMap.get('token');
   try {
  if (token) {
    window.location.href = `${window.location.origin}${environment.routeTo}/apply/${token}`;

  } else {
    console.error('Token nije pronađen u URL-u');
     this.error = 'Token nije pronađen u URL-u';
  }

    } catch (err) {

      this.error = 'Poveznica je nevažeća ili istekla. Kliknite za gumb za slanje nove poveznice.';
       console.error('Greška prilikom preusmjeravanja:', err);
    } finally {
      this.loading = false;

    }
  }
}





